function toLower(value) {
  return String(value || '').trim().toLowerCase();
}

export function deriveRoleFlags(userData = {}, claims = {}) {
  const docRoles = Array.isArray(userData.roles) ? userData.roles : [];
  const claimRoles = Array.isArray(claims.roles) ? claims.roles : [];

  const roleSet = new Set([...docRoles, ...claimRoles, userData.role, claims.role].map(toLower).filter(Boolean));

  const developer = Boolean(
    userData.developer === true
    || claims.developer === true
    || roleSet.has('developer')
  );

  const beheer = Boolean(
    userData.beheer === true
    || claims.beheer === true
    || roleSet.has('beheer')
    || roleSet.has('manager')
    // Backward compatibility during migration from legacy fields.
    || userData.isSuperAdmin === true
    || claims.isSuperAdmin === true
    || userData.isGlobalAdmin === true
    || claims.isGlobalAdmin === true
    || roleSet.has('superadmin')
    || roleSet.has('super-admin')
  );

  const uitvoerder = Boolean(
    userData.uitvoerder === true
    || claims.uitvoerder === true
    || roleSet.has('uitvoerder')
    || roleSet.has('uitvoering')
    // Backward compatibility during migration from legacy fields.
    || userData.admin === true
    || claims.admin === true
    || roleSet.has('admin')
  );

  const technician = Boolean(
    userData.technician === true
    || claims.technician === true
    || roleSet.has('technician')
  );

  const collega = Boolean(
    userData.collega === true
    || claims.collega === true
    || roleSet.has('collega')
    || (!technician && !uitvoerder && !beheer && !developer)
  );

  return {
    collega,
    technician,
    uitvoerder,
    beheer,
    developer,
  };
}

export function buildRoleCapabilities(roleFlags = {}) {
  const flags = { ...roleFlags };
  const canManageAllVestigingen = Boolean(flags.beheer || flags.developer);
  const canManageAssignedVestiging = Boolean(flags.uitvoerder || canManageAllVestigingen);
  const canUseWeekTechnician = Boolean(flags.technician);
  const canAssignToColleague = Boolean(flags.uitvoerder || flags.beheer || flags.developer);

  return {
    ...flags,
    canManageAllVestigingen,
    canManageAssignedVestiging,
    canUseWeekTechnician,
    canAssignToColleague,
  };
}
